/**
 * L'Invoice project translations - UI chrome section
 */

const ui = {
  common: {
    add: "Add",
    clear: "Clear",
    clearField: "Clear {{field}}",
    downloading: "Downloading...",
    editNamed: "Edit {{name}}",
    enterCountry: "Enter your Country",
    enterValidEmail: "Enter a valid email address",
    error: "Error",
    errorPrefix: "Error:",
    fieldRequired: "{{field}} is required",
    generating: "Generating...",
    goToStores: "Go to stores",
    loadDataFailed: "Failed to load data",
    loading: "Loading…",
    moreActions: "More actions",
    no: "No",
    noCountriesFound: "No countries found",
    noLanguagesFound: "No languages found",
    noMatches: "No matches",
    noXeroIntegration: "You have no integration with Xero!",
    registrationCode: "Registration Code",
    remove: "Remove",
    selectCountry: "Select country",
    selectCurrency: "Select currency",
    selectDate: "Select date",
    selectState: "Select state",
    serverError: "Server error. Please try again.",
    somethingWentWrong: "Something went wrong. Please try again.",
    stepNumber: "Step {{number}}",
    submit: "Submit",
    systemMessage: "System message",
    thisFieldIsRequired: "This field is required",
    typeToSearch: "Type to search...",
    unexpectedError: "Unexpected error. Please try again.",
    unknownCountry: "Unknown Country",
    unnamedBank: "Unnamed bank",
    upload: "Upload",
    uploadError: "Upload Error",
    uploadFilesFailed: "Failed to upload files",
    uploading: "Uploading...",
    wizardSteps: "Wizard steps",
    yes: "Yes",
  },
  attachments: {
    title: "Attachments",
    addAttachments: "Add attachments",
    addFiles: "Add files",
    alreadyAttached: "Already attached",
    invoiceNotFound: "Invoice not found.",
    loading: "Loading attachments",
    noAttachments: "No attachments yet.",
    readyToUpload: "Ready to upload ({{count}})",
    subtitle: "Supporting files for this invoice.",
  },
  bank: {
    deleteFailed: "Failed to delete bank",
    setDefaultFailed: "Failed to update default bank",
    hideAccountNumber: "Hide account number",
    showAccountNumber: "Show account number",
  },
  bankingInfo: {
    accountName: "Account name",
    accountNumber: "Account Number",
    add: "Add banking info",
    addNew: "Add new banking info",
    bankCode: "Bank code",
    bankName: "Bank name",
    edit: "Edit banking info",
    hideAccountNumber: "Hide account number",
    loadingRequirements: "Loading banking field requirements…",
    localBankCode: "Local Bank Code",
    localBankCodeHint: "Local Bank Code (e.g. Routing, IFSC, Sort Code, BSB, Transit)",
    location: "Location",
    routingNumber: "Routing number",
    selectOrAdd: "Select or add banking info",
    showAccountNumber: "Show account number",
    sortCode: "Sort Code",
  },
  bulkDelete: {
    allPagesQuestion: "Do you want to delete {{count}} invoice(s) matching the current filters?",
    selectedQuestion: "Do you want to delete these invoices?",
  },
  companyProfile: {
    defaultMessage: "Please complete your company profile by specifying the country in the settings.",
    goToProfileSettings: "Go to Profile Settings",
    incompleteTitle: "Company Profile Incomplete",
  },
  convertToTransactions: {
    action: "Convert to transactions",
    convert: "Convert",
    description: "You are about to convert the invoices to transactions",
    noIntegration: "You have no integration for converting invoices to transactions!",
    title: "Convert Invoices To Transactions",
  },
  countrySpecifics: {
    languageRecordNotFound: "Language record id not found for country",
    countryCodeRequired: "Country code is required",
    skuRequired: "SKU is required",
    descriptionRequired: "Description is required",
    classificationCodeRequired: "Classification code is required",
  },
  customerForm: {
    addTitle: "Add New Customer",
    customerCreated: "Customer created",
    customerUpdated: "Customer updated",
    editTitle: "Edit Customer",
    enterAddressLine1: "Enter your Address Line 1 (Street)",
    enterAddressLine2: "Enter your Address Line 2 (Street)",
    enterBusinessName: "Enter your Business Name",
    enterCity: "Enter your City",
    enterContactPerson: "Enter your Contact Person",
    enterInvoicingEmail: "Enter your Invoicing Email",
    enterPeppolId: "Enter your Peppol ID",
    enterPostalCode: "Enter your Postal Code",
    enterPreferredLanguage: "Enter your Preferred Language For PDF",
    enterSendingMethod: "Enter your Sending Method",
    enterState: "Enter your State",
    enterTaxNumber: "Enter your Tax Number",
    saveCustomer: "Save Customer",
  },
  editInvoice: {
    bankInfo: "Bank info",
    bankRequired: "Bank is required",
    bankWithId: "Bank {{id}}",
    createCustomerFailed: "Failed to create customer: {{message}}",
    creatingPreview: "Creating Preview...",
    customerRequired: "Customer is required",
    customerWithId: "Customer {{id}}",
    description: "Review and edit the invoice data extracted from your files",
    editBank: "Edit bank",
    invoiceCustomer: "Invoice customer",
    invoiceDetails: "Invoice Details",
    itemNumber: "Item {{number}}",
    loadingData: "Loading invoice data...",
    noLineItems: "No line items added yet. Click \"Add Item\" to add your first item.",
    previewInvoice: "Preview Invoice",
    selectBank: "Select Bank",
    selectCustomer: "Select Customer",
  },
  edocuments: {
    downloadFailed: "Failed to download e-document",
  },
  exemption: {
    approve: "Approve",
    certificateId: "Certificate ID",
    changeExpirationDate: "Change Expiration date",
    countryLabel: "Country:",
    createCertificate: "Create Exemption Certificate",
    customerLabel: "Customer:",
    descriptionOfGoods: "Description of Goods or Services",
    directionLabel: "Direction:",
    goBackConfirm: "Do you really want to go back? All data will be lost.",
    incoming: "Incoming",
    markAsSent: "Mark as Sent",
    outgoing: "Outgoing",
    regionLabel: "Exempt region:",
    taxRegistrationNumber: "Tax Registration number",
    typeLabel: "Type of Exemption:",
  },
  history: {
    description: "History of transactions for this invoice",
    download: "Download History",
    title: "Invoice transaction history",
  },
  invoice: {
    details: "Invoice Details",
    processFailed: "Failed to process invoice",
    vatTemplateTitle: "VAT Invoice Template",
    salesTaxTemplateTitle: "Sales Tax Invoice Template",
    customerRequired: "Customer is required",
    bankRequiredForCustomer: "Bank is required for this customer",
    currencyRequired: "Currency is required",
    invoiceDateRequired: "Invoice date is required",
    dueDateRequired: "Due date is required",
  },
  items: {
    addNewItem: "Add new item",
    itemDescription: "Item description",
    itemTitle: "Item title",
    tax: "Tax",
    title: "Title",
  },
  languageForPdf: {
    add: "Add Language For PDF",
    addCountry: "Add Country for e-docs",
    edit: "Edit Language For PDF",
    label: "Language for PDF",
    selectPlaceholder: "Select a Language for PDF",
  },
  pdfReview: {
    addBankingInfo: "Add banking information",
    addCustomer: "Add customer",
    addRecognizedBankingInfo: "Add recognized banking information",
    addRecognizedCustomer: "Add recognized customer",
    addRecognizedVatNumber: "Add recognized VAT number",
    addSupplierVatNumber: "Add supplier VAT number",
    backToDocuments: "Back to Documents",
    bankCreateFailed: "Failed to create banking information.",
    bankCurrencyMismatch: "Banking information was created, but it does not match the invoice currency. Please select or create banking information for this currency.",
    bankingInfo: "Banking info",
    bankNotLinked: "Banking information was created, but it could not be linked automatically. Please select it from the list.",
    bankUnmatched: "Recognized from the PDF, but not found in your saved banking information.",
    clearBankingInfo: "Clear banking info",
    clearCity: "Clear city",
    clearCommentNote: "Clear comment / note",
    clearCurrency: "Clear currency",
    clearCustomer: "Clear customer",
    clearInvoiceNumber: "Clear invoice number",
    clearPostalCode: "Clear postal code",
    clearRegistrationCode: "Clear registration code / company number",
    clearStreet: "Clear street",
    clearSupplierName: "Clear supplier name",
    clearSupplierVatNumber: "Clear supplier VAT number",
    commentNote: "Comment / Note",
    createInvoice: "Create invoice",
    creatingInvoice: "Creating invoice...",
    customer: "Customer",
    customerCreateFailed: "Failed to create customer.",
    customerNotLinked: "Customer was created, but it could not be linked automatically. Please select it from the list.",
    customerUnmatched: "Recognized from the PDF, but not found in your saved customers.",
    discountAmount: "Discount amount",
    documentBasics: "Document basics",
    documents: "Documents",
    documentTitle: "Review imported invoice — L’Invoice",
    draftSaved: "Draft saved successfully.",
    draftSaveFailed: "Draft could not be saved. Please try again.",
    dueDate: "Due date",
    invoiceCreated: "Invoice created successfully. You’ll be redirected to Documents shortly.",
    invoiceCreateFailed: "Invoice could not be created. Please check the form and try again.",
    invoiceDate: "Invoice date",
    invoiceNumber: "Invoice number",
    loadFailed: "Failed to load imported invoice",
    loadFailedDocumentTitle: "Failed to load imported invoice — L’Invoice",
    loadFailedMessage: "Failed to load imported invoice.",
    loading: "Loading imported invoice…",
    previewPlaceholder: "PDF preview will appear here.",
    registrationCode: "Registration code / Company number",
    returnToDocuments: "Return to Documents and open the draft again.",
    saveDraft: "Save draft",
    savingDraft: "Saving draft...",
    selectOrAddCustomer: "Select or add customer",
    selectSupplierVatNumber: "Select supplier VAT number",
    sourcePdf: "Source PDF",
    street: "Street",
    subtitle: "Review the extracted data, make any necessary changes, and save the invoice.",
    subtotalAmount: "Subtotal amount",
    supplier: "Supplier",
    supplierName: "Supplier name",
    supplierVatNumber: "Supplier VAT number",
    taxAmount: "Tax amount",
    title: "Review imported invoice",
    totalAmount: "Total amount",
    unavailable: "Imported draft unavailable",
    unavailableDocumentTitle: "Imported draft unavailable — L’Invoice",
    vatNotLinked: "VAT number was created, but it could not be linked automatically. Please select it from the list.",
    vatPercentage: "VAT percentage",
    vatUnmatched: "Recognized from the PDF, but not found in your saved VAT numbers.",
    validation: {
      bank: "Select saved banking information before creating the invoice.",
      customer: "Select a saved customer before creating the invoice.",
      invoiceDetails: "Complete the required invoice details before creating the invoice.",
      lineItemInvalid: "Each submitted line item must include a description, quantity, and unit price.",
      lineItemMissing: "Add at least one line item before creating the invoice.",
      supplierDetails: "Complete the required supplier details before creating the invoice.",
      taxAmbiguous: "Only one resolved tax reference can be used when creating the invoice. Please keep just one tax ID selected.",
      taxMissing: "Select a saved VAT, sales tax, or tax number before creating the invoice.",
    },
  },
  peppolRegistration: {
    attachDescription: "An organization identification document is required to enable the Peppol connection. It is essential that the document shows both the identifier (the one just provided above) and the company name to complete the validation.",
    attachExamples: "Some examples of valid documents are: company registration, VAT identification document, company tax identification card, or, as a last option, a received invoice.",
    attachTitle: "Attach document to validate your identity",
    chooseIdentifierType: "Choose identifier type",
    completeRegistration: "Complete Registration",
    consent: "I consent to the processing of my personal data for Peppol registration purposes",
    documentGenerated: "Document generated and downloaded successfully! You can generate and download it again if needed.",
    downloadDescription: "Generate and download the Peppol registration document for your company.",
    downloadTitle: "Download Registration Document",
    enterCompanyName: "Enter Company Name",
    enterIdentifier: "Enter Identifier",
    generateDocument: "Generate Document",
    generateHint: "Click the button below to generate your Peppol registration document.",
    generatingDocument: "Generating document...",
    identifier: "Identifier",
    identifierType: "Identifier Type",
    onlyOneFile: "Only one file is allowed. Please select a single file.",
    uploadedFile: "Uploaded file:",
    uploadIdentityDocument: "Upload identity document",
    uploadSignedAction: "Upload signed document",
    uploadSignedDescription: "Please upload the previously downloaded and signed document for Peppol registration.",
    verificationFailed: "Verification failed. Please try again.",
  },
  sendEinvoices: {
    changeMethod: "Change Method",
    description: "Here you can select multiple e-invoices to send.",
    multiple: "Multiple",
    title: "Send E-invoices?",
  },
  sendingMethods: {
    bis3: "Peppol (Standard – BIS 3.0) (default)",
    pint: "Peppol (International – PINT)",
  },
  settingsDelete: {
    languageText: "Do you want to delete the <b>{{country}}</b> with the language for PDF set to <b>{{language}}</b>?",
    peppolText: "Are you sure you want to delete the Peppol number <b>{{peppolNumber}}</b>?",
    taxIdText: "Are you sure you want to delete the Tax ID <b>{{taxId}}</b> for <b>{{country}}</b>?",
  },
  supplierVat: {
    appointLappa: "I'd like to appoint Lappa as my tax representative",
    clearPeriodicity: "Clear periodicity",
    clearReason: "Clear reason",
    countrySpecifics: "Country specifics",
    enterTinNumber: "Enter TIN number",
    nexusEstablished: "Nexus Established",
    selectLand: "Select land",
    selectPeriodicity: "Select periodicity",
    selectReason: "Select reason",
    selectTypeOfActivity: "Select type of activity",
    typeOfActivity: "Type of activity",
    validFrom: "Valid from",
  },
  tax: {
    addNew: "Add new tax",
    edit: "Edit tax",
    editNamed: "Edit tax {{name}}",
    enterName: "Enter tax name",
    enterRate: "Enter rate",
    name: "Tax name",
    rate: "Rate",
  },
  templateCustomer: {
    address: "Address:",
    country: "Country:",
    email: "Email:",
    name: "Name:",
    vatNumber: "VAT number:",
  },
  templateDetails: {
    dueDate: "Due Date",
    invoiceDate: "Invoice Date",
  },
  templateEdit: {
    addNewTaxId: "Add new Tax ID",
    address: "Address",
    businessType: "Business Type",
    invoiceRecipient: "Invoice Recipient",
    invoiceSender: "Invoice Sender",
    optional: "optional",
    reasonForExemption: "Reason For Exemption",
    required: "required",
    salesTaxNumber: "Sales Tax Number",
    sellerTaxId: "Seller tax ID in customer's country",
    sellerTaxIdTooltip: "Certain countries require invoices to include your business tax ID (TIN, GST, etc.)",
    sellerVatNumber: "Seller VAT number",
  },
  templateSaveBar: {
    editExemption: "Edit Exemption",
    reviewAndSendCertificate: "Review & Send Certificate",
    reviewAndSendInvoice: "Review & Send Invoice",
    saveAsDraft: "Save as draft",
    sendExemption: "Send Exemption",
  },
  totals: {
    discount: "Discount:",
    discountDescription: "Discount Description",
    enterDiscountAmount: "Enter discount amount",
    enterDiscountDescription: "Enter discount description",
    selectOrAddTax: "Select or add tax",
    subtotal: "Subtotal:",
    subtotalAfterDiscount: "Subtotal after discount:",
    taxAndDiscount: "Tax and Discount",
    title: "Totals",
    total: "Total:",
    totalTaxAmount: "Total Tax Amount:",
  },
  unsavedChanges: {
    discard: "Discard changes",
    text1: "You have unsaved changes.",
    text2: "If you leave now, your changes will be lost.",
    text3: "To keep your progress, save the draft before leaving.",
    title: "Discard changes?",
  },
  upload: {
    enterCustomerName: "Enter customer name",
    excelAction: "Upload Excel file",
    excelDescription: "Please select an Excel file to upload.",
    excelInvalidType: "Please select a valid Excel file (.xlsx or .xls)",
    excelSelectRequired: "Please select an Excel file to upload",
    excelUploadFailed: "Failed to upload Excel file. Please try again.",
    filesDescription: "Please attach files you want to upload.",
    filesTitle: "Upload files",
    filesUploadFailed: "Failed to upload files. Please try again.",
    fromXero: "Upload from Xero",
    integrations: "Integrations",
    invoiceStatus: "Invoice Status",
    pdfAction: "Upload PDF file",
    pdfDescription: "Upload one PDF invoice and we'll extract the data for you.",
    pdfHelper: "PDF only • Maximum file size 50 MB • One file at a time",
    pdfMaxSize: "The file size must not exceed 50 MB.",
    pdfOnlyOne: "You can upload only one PDF at a time.",
    pdfSelectRequired: "Please select a PDF file.",
    pdfTitle: "Import invoice from PDF",
    selectAtLeastOneFile: "Please select at least one file to upload",
    selectedFiles: "Selected files:",
    statusPaid: "Paid",
    statusPending: "Pending",
    uploadPdfInvoices: "Upload pdf invoices",
    xeroDescription: "You are about to upload the invoices",
  },
};

export default ui;
